const emailkeys =  {
    SERVICE_ID: 'service_ub88vmm',
    TEMPLATE_ID: 'template_ipnee5r',
    PUBLIK_KEY: 'c-CPyLaXUr8vtRe7f',
};
export default emailkeys;